import errorHandler from "../../handlers/errorHandler";
import successHandler from "../../handlers/successHandler";
import { revenueSettingsService } from "../../services/revenueSettings.service";
import revenueType from "./revenueSettingsTypes";

/**
 * Get all referrals
 **/

export const getAllRevenueSettings = (page) => async (dispatch) => {
  try {
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: true });
    const response = await revenueSettingsService.getAllRevenueSettings(page);
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
    dispatch({ type: revenueType["ALL_REFERRALS"], payLoad: response });
  } catch (error) {
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
  }
};

/**
 * Get all referrals
 **/

export const showARevenueSettings = (id, type) => async (dispatch) => {
  try {
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: true });
    const response = await revenueSettingsService.showARevenueSettings(
      id,
      type,
    );
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
    dispatch({ type: revenueType["ALL_REFERRALS"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
  }
};

/**
 * Get all referrals
 **/

export const getAllRevenueSettingsNoPagination =
  (payload, page) => async (dispatch) => {
    try {
      dispatch({ type: revenueType["DOWNLOADING"], payLoad: true });
      const response = await revenueSettingsService.getAllReferralsNoPagination(
        payload,
        page,
      );
      dispatch({ type: revenueType["DOWNLOADING"], payLoad: false });
      // dispatch({ type: revenueType["ALL_REFERRALS"], payLoad: response });
      return response;
    } catch (error) {
      dispatch({ type: revenueType["DOWNLOADING"], payLoad: false });
    }
  };

/**
 * Get all my referrals
 **/

export const getMyReferralsAction = () => async (dispatch) => {
  try {
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: true });
    const response = await revenueSettingsService.getMyReferrals();
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
    dispatch({ type: revenueType["GET_MY_REFERRALS"], payLoad: response });
  } catch (error) {
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
  }
};

/**
 * Search referrals
 **/

export const searchRevenueSettingsAction = (payload) => async (dispatch) => {
  try {
    dispatch({ type: revenueType["SEARCHING"], payLoad: true });
    const response = await revenueSettingsService.searchReferrals(payload);
    dispatch({ type: revenueType["SEARCHING"], payLoad: false });
    dispatch({ type: revenueType["SEARCH_REFERRALS"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: revenueType["SEARCHING"], payLoad: false });
  }
};

/**
 * Filter referrals
 **/

export const filterRevenueSettingsAction =
  (payload, page) => async (dispatch) => {
    try {
      dispatch({ type: revenueType["REVENUE_SETTINGS_FILTERING"], payLoad: true });
      const response = await revenueSettingsService.filterReferrals(
        payload,
        page,
      );
      dispatch({ type: revenueType["REVENUE_SETTINGS_FILTERING"], payLoad: false });
      dispatch({
        type: revenueType["REVENUE_SETTINGS_FILTER"],
        payLoad: response,
      });
      return response;
    } catch (error) {
      dispatch({ type: revenueType["REVENUE_SETTINGS_FILTERING"], payLoad: false });
      errorHandler(error, true);
    }
  };

/**
 * Edit revenue settings
 **/

export const editRevenueSettingsAction =
  (payload, page) => async (dispatch) => {
    try {
      dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: true });
      const response = await revenueSettingsService.editRevenueSettings(
        payload,
        page,
      );
      dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
      // dispatch({ type: revenueType["FILTER_REFERRALS"], payLoad: response });
      successHandler(response, true);
      return response;
    } catch (error) {
      dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
      errorHandler(error, true);
    }
  };

/**
 * Edit revenue settings
 **/

export const storeRevenueSettingsAction = (payload) => async (dispatch) => {
  try {
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: true });
    const response = await revenueSettingsService.storeRevenueSettings(payload);
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: revenueType["LOADING_REFERRALS"], payLoad: false });
    errorHandler(error, true);
  }
};
